/**
 * AdminLayout (#1528) — the Global Admin shell. Mirrors `PageLayout`
 * (shared `Header` + `AdminModeBanner` + `<Outlet/>`) but swaps the
 * workspace `Sidebar` for the grouped `AdminRail`: while under
 * `/admin/*` the left pane is the admin section rail, not the
 * workspace nav. The superadmin gate (`RequireSuperadmin`) still wraps
 * this from `App.tsx`; this component is pure chrome.
 *
 * The main column's left offset (`lg:pl-[248px]`) matches the rail
 * width, same pattern as `PageLayout`'s `lg:pl-[84px]` for the
 * narrower workspace sidebar.
 */
import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from '@/components/layout/Header'
import { AdminModeBanner } from '@/components/layout/AdminModeBanner'
import { AdminRail } from './AdminRail'

export function AdminLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-dvh bg-background">
      <Header onMenuClick={() => setMobileMenuOpen(!mobileMenuOpen)} />

      {/* Desktop rail */}
      <div className="hidden lg:block">
        <AdminRail />
      </div>

      {/* Mobile rail overlay */}
      {mobileMenuOpen && (
        <div className="lg:hidden">
          <div
            className="fixed inset-0 z-30 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          />
          <AdminRail />
        </div>
      )}

      <main className="min-h-[calc(100dvh-3.5rem)] pt-14 lg:pl-[248px]">
        <AdminModeBanner />
        <div className="container mx-auto p-6">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
